import dlv from 'dlv';
import axiosInstance from './axiosConfig';
import { generateBFFUrl } from '@/configs/apiEndPoints';
import { VERIFY_LEAD } from '@/configs/ecom/apis';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';

export const verifyLead = async (body: any): Promise<any> => {
  try {
    const response: any = await axiosInstance.post(generateBFFUrl(VERIFY_LEAD), body);
    return dlv(response, 'data.data', {});
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};
